import type { LicenceResponse } from '@shared/schemas';

import api from '@/shared/api/api-client';

import type { MyLicenceGateway } from './my-licence.gateway';

/**
 * Real implementation over the shared api client; the single place that knows the
 * My Licence endpoints (kept 1:1 with the original `/licence` page: read via
 * `GET /licences/current`, rename via `PATCH /licences/:id`). `api.get/patch`
 * unwrap the `{ success, data }` envelope.
 */
export const httpMyLicenceGateway: MyLicenceGateway = {
  loadCurrentLicence: () => api.get<LicenceResponse>('/licences/current'),

  updateLicence: (id, name) => api.patch<LicenceResponse>(`/licences/${id}`, { name: name.trim() }),
};
